var React = require('react');

function Dropdown (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_211","data-name":"Path 211","d":"M-310.609,385.78l-3.208,3.208-2.292,2.292-5.5-5.5","transform":"translate(322.14 -385.25)","fill":"none","stroke":"#fff","strokeMiterlimit":"10","strokeWidth":"1.5"}));
}

Dropdown.defaultProps = {"width":"12.061","height":"7.091","viewBox":"0 0 12.061 7.091"};

module.exports = Dropdown;

Dropdown.default = Dropdown;
